module.exports = {"name":"Obrazok s textom","icon":"<i class='material-icons'>art_track</i>","widget":[{"type":"image","initData":{"img":"https://placehold.it/200x200"},"width":200,"height":200},{"type":"pure-html","initData":{"html":"Popis k obrazku"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/text-image/text-image.json
// module id = 397
// module chunks = 0